module.exports.run = function(date, format = 'DD/MM/YYYY'){

  const monthsShort = 'jan_fév_mar_avr_mai_juin_juil_août_sept_oct_nov_déc'.split('_');
  const monthsLong = 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_');
  const daysLong = 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_');
  const daysShort = 'dim_lun_mar_mer_jeu_ven_sam'.split('_');

  const ensureTwo = number => {
    const string = (number).toString();
    if(string.length === 1){
      return `0${string}`;
    }
    return string;
  };

  if(
    !date ||
    (typeof date !== 'string' && !(date instanceof Date))
  ){
    console.warn(`unable to format date ${date}`);
    return;
  }

  try {
    if(typeof date === 'string'){

      let tmp = new Date(date);

      if(isNaN(tmp)){
          /* handle safari */
        tmp = new Date(date.replace(/-/g, '/'));
      }

      date = tmp;
    }

    if(format === 'dddd DD MMMM YYYY') return `${daysLong[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]} ${date.getFullYear()}`;
    if(format === 'dddd DD MMMM HH:mm') return `${daysLong[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]} ${ensureTwo(date.getHours())}:${ensureTwo(date.getMinutes())}`;
    if(format === 'dddd DD MMMM') return `${daysLong[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]}`;
    if(format === 'dddd DD MMMM à HH:mm') return `${daysLong[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]} à ${ensureTwo(date.getHours())}:${ensureTwo(date.getMinutes())}`;
    if(format === 'DD/MM') return `${ensureTwo(date.getDate())}/${ensureTwo(date.getMonth()+1)}`;
    if(format === 'MM') return `${ensureTwo(date.getMonth()+1)}`;
    if(format === 'dddd') return daysLong[date.getDay()];
    if(format === 'YY') return date.getFullYear().toString().substr(2);
    if(format === 'DD MM YY') return `${ensureTwo(date.getDate())} ${ensureTwo(date.getMonth()+1)} ${date.getFullYear().toString().substr(2)}`;
    if(format === 'ddd MM YY') return daysShort[date.getDay()] + ' ' + ensureTwo(date.getDate()) + ' ' + ensureTwo(date.getMonth()+1) + ' ' + date.getFullYear().toString().substr(2);
    if(format === 'ddd DD/MM') return `${daysShort[date.getDay()]} ${ensureTwo(date.getDate())}/${ensureTwo(date.getMonth()+1)}`;
    if(format === 'DD MMM') return `${ensureTwo(date.getDate())} ${monthsShort[date.getMonth()]}`;
    if(format === 'HH.mm') return ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DDD MMMM') return daysLong[date.getDate()] + ' ' + date.getDate() + ' ' + monthsLong[date.getMonth()];
    if(format === 'DDD MMMM HH:mm') return daysLong[date.getDate()] + ' ' + monthsLong[date.getMonth()] + ' ' + ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DD-MM-YYYY') return ensureTwo(date.getDate()) + '-' + ensureTwo((date.getMonth()+1)) + '-' + date.getFullYear();
    if(format === 'DD MMMM') return date.getDate() + ' ' + monthsLong[date.getMonth()];
    if(format === 'DD MMMM YYYY') return date.getDate() + ' ' + monthsLong[date.getMonth()] + ' ' + date.getFullYear();
    if(format === 'HH:mm') return ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DD MM YYYY HH:mm') return date.getDate() + ' ' + (date.getMonth()+1) + ' ' + date.getFullYear() + ' ' + ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DD-MM-YYYY HH:mm') return ensureTwo(date.getDate()) + '-' + ensureTwo(date.getMonth()+1) + '-' + date.getFullYear() + ' ' + ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DD MMM YYYY') return date.getDate() + ' ' + monthsShort[date.getMonth()] + ' ' + date.getFullYear();
    if(format === 'DD MMMM YYYY HH:mm') return date.getDate() + ' ' + monthsLong[date.getMonth()] + ' ' + date.getFullYear() + ' ' + ensureTwo(date.getHours()) + ':' + ensureTwo(date.getMinutes());
    if(format === 'DDD MMMM YYYY') return daysLong[date.getDay()] + ' ' + date.getDate() + ' ' + monthsLong[date.getMonth()] + ' ' + date.getFullYear();
    if(format === 'DDMMYY') return ensureTwo(date.getDate()) + ensureTwo(date.getMonth()+1) + date.getFullYear().toString().substr(2);
    if(format === 'YYYY-MM-DD') return `${date.getFullYear()}-${ensureTwo(date.getMonth()+1)}-${ensureTwo(date.getDate())}`;
    if(format === 'YYYY-MM-DD HH:mm') return `${date.getFullYear()}-${ensureTwo(date.getMonth()+1)}-${ensureTwo(date.getDate())} ${ensureTwo(date.getHours())}:${ensureTwo(date.getMinutes())}`;
    if(format === 'DD MMMM YYYY') return `${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]} ${date.getFullYear()}`;
    if(format === 'ddd DD MMM YYYY') return `${daysShort[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsShort[date.getMonth()]} ${date.getFullYear()}`;
    if(format === 'ddd DD MMM') return `${daysShort[date.getDay()]} ${ensureTwo(date.getDate())} ${monthsShort[date.getMonth()]}`;
    if(format === 'DD MMMM HH:mm') return `${ensureTwo(date.getDate())} ${monthsLong[date.getMonth()]} ${ensureTwo(date.getHours())}:${ensureTwo(date.getMinutes())}`;
  } catch(err) {
    console.warn('formatDate failed', err);
  }
};

